import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { BaseSiteService, CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { catchError, combineLatest, concatMap, forkJoin, from, map, mergeMap, Observable, of, switchMap, take, toArray } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { HelpnfaqsearchPipe } from '../../cms-common/Pipes/helpnfaqsearch.pipe';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-help-faq-second',
    templateUrl: './help-faq-second.component.html',
    styleUrls: ['./help-faq-second.component.scss'],
    standalone: false
})
export class HelpFaqSecondComponent {
  constructor(public component: CmsComponentData<CmsBannerComponent>, public accessService: ContentService, private cmsService: CmsService, public cd: ChangeDetectorRef, private userInfoService: UserInfoService, protected config: OccConfig, private baseSiteService: BaseSiteService, private renderer: Renderer2, private activatedRoute: ActivatedRoute) { }
  secondnode: Observable<any> = this.component.data$;
  activeIndexes: Set<string> = new Set();
  activeAccordion: number | null = null;
  mergedObject1: any = [];
  mergedObject2: any = [];
  filteredData: any[] = [];
  seallbtn: boolean = false;
  searchvalue: string = '';
  searchresults: boolean = false;
  shownoresult: boolean = false;
  userLoggedIn: boolean = false;
  userInfo: any;
  currentSite: string | undefined;
  isModalOpen = false;
  popupdata: any;
  isLoading = false;
  sublist: any[] = [];
  private activeDiv: HTMLElement | null = null;


  ngOnInit() {
    this.isLoading = true;
  
    this.secondnode.pipe(take(1)).subscribe(
      res => {
        this.loadFaqData(res);
      },
      error => {
        console.error('Error loading FAQ data:', error);
        this.isLoading = false;
      }
    );
  
    // for logged in / logged out
    this.userInfoService.userLoggedIn$.subscribe(
      res => {
        this.userLoggedIn = res;
  
        if (this.userLoggedIn) {
          this.userInfoService.getUserData().subscribe(
            res => {
              if (res) {
                this.userInfo = res;
  
                if (this.userInfo?.webEnabled === false) {
                  this.renderer.setStyle(document.querySelector('.SideContent'), 'display', 'none');
                  this.cd.detectChanges();
                }
              }
            },
            error => {
              console.error('Error fetching user data:', error);
              this.isLoading = false;
              this.cd.detectChanges();
            }
          );
        }
      },
      error => {
        console.error('Error checking login status:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
  
    // to get the current base site
    this.baseSiteService.getActive().subscribe(
      siteId => {
        this.currentSite = siteId;
      },
      error => {
        console.error('Error fetching active base site:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
  
    // for pop-up
    this.cmsService.getComponentData('contactusPagePopup').subscribe(
      res => {
        this.popupdata = res;
      },
      error => {
        console.error('Error fetching contact us popup data:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
  
    setTimeout(() => {
      this.activatedRoute.queryParams.subscribe(
        params => {
          if (params['returns']) {
            this.showAccordion(2, 'helpbtn_3');
            const helpSection = document.querySelector('.help_sectionbtns');
            if (helpSection) {
              helpSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
  
          if (params['credits']) {
            this.searchvalue = 'Credits';
          }
        },
        error => {
          console.error('Error reading query params:', error);
          this.isLoading = false;
          this.cd.detectChanges();
        }
      );
    }, 6000);

    this.cmsService.getComponentData('contactusPagePopup').subscribe(res => {
      this.popupdata = res;
    });
  }
  loadFaqData(res: any) {
    const tilesList = res.FaqAllResources.split(" ");
    this.accessService.opeffeaturedResources(tilesList).subscribe((res: any) => {
      if (Array.isArray(res.component)) {
        this.mergedObject1 = res.component;
        res.component.forEach((item: any) => {
          const subtilesList = item.faqTopics.split(" ");
          if (subtilesList.length <= 9) {
            this.accessService.opeffeaturedResources(subtilesList).subscribe((subRes: any) => {
              if (Array.isArray(subRes.component)) {
                const updatedsubRes = subRes.component.map((data: any) => ({
                  ...data,
                  parentId: item.uid,
                }));
                const uniqueEntries = updatedsubRes.filter(
                  (newItem: { uid: any }) =>
                    !this.mergedObject2.some((existingItem: { uid: any }) => existingItem.uid === newItem.uid)
                );
                this.mergedObject2 = [...this.mergedObject2, ...uniqueEntries];
                this.sortMergedObject2ByUid();
                this.isLoading = false;
                this.cd.detectChanges();
              }
            });
          } else {
            const sublistcount = subtilesList.length;
            const sublistloop = Math.ceil(sublistcount / 9); // Calculate the number of chunks
            let sliceIndex = 0;
            let lastIndex = 9;

            const observables = []; // Collect all observables

            for (let j = 0; j < sublistloop; j++) {
              const spliceList = subtilesList.slice(sliceIndex, lastIndex); 
              observables.push(this.accessService.opeffeaturedResources(spliceList));
              sliceIndex = lastIndex;
              lastIndex += 9;
            }

            // Wait for all observables to complete
            forkJoin(observables).subscribe((responses: any[]) => {
              responses.forEach((res: any) => {
                if (Array.isArray(res.component)) {
                  const updatedsubRes = res.component.map((data: any) => ({
                    ...data,
                    parentId: item.uid,
                  }));
                  this.mergedObject2 = [...this.mergedObject2, ...updatedsubRes]; // Merge arrays
                }
              });

              // Sort mergedObject2 based on uid after all responses are processed
              this.sortMergedObject2ByUid();
              this.cd.detectChanges();
            });
          }
        });
      } else if (res.component) {
        this.mergedObject1 = [res.component];
        this.isLoading = false;
        this.cd.detectChanges();
      }
      this.sortMergedObject2ByUid();
    });
  }

  // Helper method to sort mergedObject2 by uid
  sortMergedObject2ByUid() {
    this.mergedObject2.sort((a: any, b: any) => {
      // Convert uid to numbers for proper numerical sorting
      return parseInt(a.uid, 10) - parseInt(b.uid, 10);
    });
  }

  //when user searches something the following method will be useful for showing relavant searches
  applyFilter(mysearchvalue: any) {
    if (mysearchvalue.length > 0) {
      let final = mysearchvalue.trim().toLowerCase();
      const filteredData1 = new HelpnfaqsearchPipe().transform(this.mergedObject2, final);
      if (this.filteredData) {
        this.searchresults = true;
      }
      //when the search doesn't match or the user gives empty the no result will be opened
      if (final != " " && filteredData1.length < 1) {
        this.shownoresult = true;
      }
      else {
        this.shownoresult = false;
      }
      //iam assigning the filteredData1 to one variable so that i can use in html
      this.filteredData = filteredData1;
      return filteredData1
    }
    else {
      this.shownoresult = false;
      this.searchresults = false;
    }
  }
  //the following is to show all the accordions initally
  toggleDropdown(i: number, j: number) {
    const key = `${i}-${j}`;
    if (this.activeIndexes.has(key)) {
      this.activeIndexes.delete(key);
    } else {
      this.activeIndexes.add(key);
    }
  }
  isActive(i: number, j: number): boolean {
    const key = `${i}-${j}`;
    return this.activeIndexes.has(key);
  }
  //to show only the particualr accordion clicked by user
  showAccordion(index: number, myid: string) {
    this.activeAccordion = index; // Always show only the selected section
    this.seallbtn = true; // Show the "See All Topics" button
    // const div = event.target as HTMLElement;
    const div = <HTMLElement>document.getElementById(myid);
    // this.renderer.addClass(div, 'btn-active-class');
    if (this.activeDiv) {
      this.renderer.removeClass(this.activeDiv, 'btn-active-class');
    }
    if (div) {
      this.renderer.addClass(div, 'btn-active-class');
    }
    this.activeDiv = div;
    this.cd.detectChanges();
  }

  //when clicking on SEE ALL TOPICS button to make every accordion appear again
  sealltopics() {
    this.activeAccordion = null; // Reset to show all accordions
    this.seallbtn = false; // Hide the "See All Topics" button
    this.renderer.removeClass(this.activeDiv, 'btn-active-class');
    this.cd.detectChanges();
  }
  //search functions
  toggleSearchAccordion(index: any) {
    if (this.activeIndexes.has(index)) {
      this.activeIndexes.delete(index);
    } else {
      this.activeIndexes.add(index);
    }
  }
  issearchActive(index: any) {
    return this.activeIndexes.has(index);
  }
  //i wrote this for to show the results in accordions 
  toggleAccordion(item: any) {
    item.isOpen = !item.isOpen;
  }
  //for popups
  openModal() {
    this.isModalOpen = true;
    document.body.style.overflowY = 'auto';
    document.getElementById('help_Faq_commonleaving_abandonedPop_Li')!.style.display = 'block';
    const continueLink = document.querySelector('.help_Faq_commonleaving_abandonedPop_Li a');
    if (continueLink) {
      continueLink.addEventListener('click', () => {
        this.closeModal();
      });
    }
  }
  closeModal() {
    this.isModalOpen = false;
    document.body.style.overflowY = 'auto';
    document.getElementById('help_Faq_commonleaving_abandonedPop_Li')!.style.display = 'none';
  }
  ngAfterViewChecked() {
    if (this.searchvalue == 'Credits') {
      this.applyFilter(this.searchvalue);
    }
  }
}